/** Money + time formatting. Balances are integer cents server-side. */

/** Integer cents → "$12.34". */
export function formatCents(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(Math.round(cents));
  const dollars = Math.floor(abs / 100);
  const rem = abs % 100;
  return `${sign}$${dollars.toLocaleString()}.${rem.toString().padStart(2, '0')}`;
}

/** Dollars (float from a UI input) → integer cents, clamped to whole cents. */
export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}

/** Seconds remaining until an epoch-ms deadline (never negative). */
export function secondsUntil(deadlineTs: number | undefined, now: number): number {
  if (deadlineTs === undefined) return 0;
  return Math.max(0, (deadlineTs - now) / 1000);
}
